/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Verify_ErrorInputs */

const en_two_fa_verify_error = /** @type {(inputs: Two_Fa_Verify_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to verify two-factor authentication`)
};

const nl_two_fa_verify_error = /** @type {(inputs: Two_Fa_Verify_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee-factor-authenticatie kon niet worden geverifieerd`)
};

/**
* | output |
* | --- |
* | "Failed to verify two-factor authentication" |
*
* @param {Two_Fa_Verify_ErrorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_verify_error = /** @type {((inputs?: Two_Fa_Verify_ErrorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Verify_ErrorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_verify_error(inputs)
	return en_two_fa_verify_error(inputs)
});